module.exports = __webpack_public_path__ + "img/gitlab-icon.cdb26176.svg";